
const uAgent = navigator.userAgent.toLowerCase()
function inAgent(str) {
  return uAgent.indexOf(str) !== -1
}

export const isWindows = inAgent('windows')
export const isIPhone = !isWindows && inAgent('iphone')
export const isIPod = inAgent('ipod')
export const isIPad = inAgent('ipad')
export const isIOS = isIPhone || isIPod || isIPad
// Google Search App (for IOS)
export const isGSA = inAgent('gsa') && isIOS
export const isIE = /msie|trident/.test(uAgent)
export const isEdge = inAgent('edge/')
export const isAndroid = inAgent('android')

export let hasPassiveEvents = false
if (typeof window !== 'undefined') {
  const passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true
      return undefined
    }
  } as any
  window.addEventListener('testPassive', null, passiveTestOptions)
  window.removeEventListener('testPassive', null, passiveTestOptions)
}

  /**
   * Returns whether or not device is mobile for responsive:
   */
function isMobileDevice() {
  // ipads aren't mobile
  if (isIPad) {
    return false
  }

  // smaller than 736 is mobile
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height
  if (screenWidth <= 736) {
    return true
  } else if (screenWidth <= 1280 && Math.abs(window.orientation as number) === 90) {
    // Android landscape:
    return true
  } else if (screenWidth === 1080 && screenHeight === 1920 && window.orientation === 0) {
    // Galaxy S4 portrait:
    return true
  } else if (screenWidth === 1920 && screenHeight === 1080
    && Math.abs(window.orientation as number) === 90) {
    // Galaxy S4 landscape:
    return true
  }

  return false
}

/**
 * There are 4 breakpoints, 1-4, with 1 being smallest.
 * This returns which breakpoint applies for the current device.
 * NOTE: This will change with browser resize or orientation change.
 */
function breakpoint() {
  const viewport = window.innerWidth
  // TODO: values are hard-coded until we have a way to load in the breakpoints.
  // Right now these are the same as what you will find in variables.scss
  if (viewport <= 569) {
    return 1
  } else if (viewport <= 849) {
    return 2
  } else if (viewport <= 1024) {
    return 3
  } else if (viewport <= 1200) {
    return 4
  }
  return 5
}

export default { isMobileDevice, breakpoint }
